import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
  padding: 5px;
  box-shadow: 2px 4px 4px rgba(0, 0, 0, 0.15);
  position: relative;

  max-height: 80vh;

  & img {
    object-fit: cover;
    max-width: 100%;
    max-height: 77vh;
    height: auto;
  }
`;

export const Close = styled.button`
  position: absolute;
  top: 3px;
  right: 5px;
  width: 30px;
  height: 30px;
  background-color: #9e9e9e7d;
  box-shadow: 2px 4px 4px rgb(0 0 0 / 15%);
  padding: 4px;
  border: solid 1px #9e9e9e;
  border-radius: 50px;
  outline: none;
  cursor: pointer;
`;
